import { render, staticRenderFns } from "./CombineFeed.vue?vue&type=template&id=3c17ff8a&scoped=true&"
import script from "./CombineFeed.vue?vue&type=script&lang=js&"
export * from "./CombineFeed.vue?vue&type=script&lang=js&"
import style0 from "./CombineFeed.vue?vue&type=style&index=0&id=3c17ff8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c17ff8a",
  null
  
)

export default component.exports